<!-- ======= Patients Nav (New) (Start) ======= -->
@if (newSidebar) {
  @if (loginService.premissions?.Dashboard) {
    <a
      class="as-nav__item"
      [class.as-nav__item--active]="activeNavItem === 'dashboard'"
      role="button"
      tabindex="0"
      (click)="goToDashboard()"
      (keyup.enter)="goToDashboard()"
      (keyup.space)="goToDashboard()"
    >
      <mat-icon class="as-nav__icon">home</mat-icon>
      <span class="as-nav__label">
        {{ 'GUI.dashboard.labels.dashboard' | translate }}
      </span>
    </a>
  }

  <a
    class="as-nav__item"
    [class.as-nav__item--active]="patientSearchOpen"
    role="button"
    tabindex="0"
    [attr.aria-expanded]="patientSearchOpen"
    (click)="togglePatientSearch()"
    (keyup.enter)="togglePatientSearch()"
    (keyup.space)="togglePatientSearch()"
  >
    <mat-icon class="as-nav__icon">person</mat-icon>
    <span class="as-nav__label">{{ 'GUI.Patients.titles.Patient Search' | translate }}</span>
    <mat-icon class="as-nav__chevron" [class.as-nav__chevron--open]="patientSearchOpen"
      >expand_more</mat-icon
    >
  </a>

  @if (patientSearchOpen) {
    <div class="as-search-panel">
      <div class="as-search-panel__tabs">
        <button
          class="as-search-panel__tab"
          [class.as-search-panel__tab--active]="idp === 1"
          (click)="idp = 1"
        >
          {{ 'GUI.Patients.ID' | translate }}
        </button>
        <button
          class="as-search-panel__tab"
          [class.as-search-panel__tab--active]="idp === 0"
          (click)="idp = 0"
        >
          {{ 'GUI.Patients.Passport' | translate }}
        </button>
      </div>

      <div class="as-search-panel__fields">
        <input
          class="as-search-panel__input"
          [class.as-search-panel__input--invalid]="invalidi"
          type="text"
          placeholder="{{ 'GUI.Placeholders.ID Number' | translate }}"
          [(ngModel)]="id"
          (keyup)="invalidi = ''; trysearch()"
          pattern="[A-Za-z0-9\-]+"
        />
        @if (invalidi) {
          <span class="as-search-panel__validation-msg">
            {{ 'GUI.Patients.Invalid ID Number' | translate }}
          </span>
        }
        <input
          class="as-search-panel__input"
          [class.as-search-panel__input--invalid]="invalidf"
          type="text"
          placeholder="{{ 'GUI.Placeholders.First Name' | translate }}"
          [(ngModel)]="first"
          (keyup)="invalidf = ''; trysearch()"
        />
        @if (invalidf) {
          <span class="as-search-panel__validation-msg">
            {{ 'GUI.Patients.Please fill in first name' | translate }}
          </span>
        }
        <input
          class="as-search-panel__input"
          [class.as-search-panel__input--invalid]="invalidl"
          type="text"
          placeholder="{{ 'GUI.Placeholders.Last Name' | translate }}"
          [(ngModel)]="last"
          (keyup)="invalidl = ''; trysearch()"
        />
        @if (invalidl) {
          <span class="as-search-panel__validation-msg">
            {{ 'GUI.Patients.Please fill in last name' | translate }}
          </span>
        }
        <input
          class="as-search-panel__input"
          type="tel"
          placeholder="{{ 'GUI.General.Patient Details Form.Mobile' | translate }} / {{ 'GUI.Placeholders.Phone' | translate }}"
          [(ngModel)]="phone"
          (keyup)="trysearch()"
        />
      </div>

      <div class="as-search-panel__actions">
        <button
          class="as-search-panel__btn-search"
          [disabled]="isSearchButtonDisabled"
          (click)="emitSearch(true)"
        >
          <mat-icon class="as-search-panel__btn-icon">search</mat-icon>
          <span>{{ 'GUI.General.Buttons.Search' | translate }}</span>
        </button>
        <button class="as-search-panel__btn-clear" (click)="clear()">
          <mat-icon class="as-search-panel__btn-icon">cancel</mat-icon>
          <span>{{ 'GUI.General.Buttons.Clear' | translate }}</span>
        </button>
        <button class="as-search-panel__new-patient" (click)="requestAddPatient()">
          <mat-icon class="as-search-panel__btn-icon">add_circle</mat-icon>
          <span>{{ 'GUI.General.Buttons.New Patient' | translate }}</span>
        </button>
      </div>
    </div>
  }

  @if (loginService.showAWL()) {
    <a
      class="as-nav__item"
      [class.as-nav__item--active]="activeNavItem === 'todays-list'"
      role="button"
      tabindex="0"
      (click)="setActiveNav('todays-list'); emitAwl()"
      (keyup.enter)="setActiveNav('todays-list'); emitAwl()"
      (keyup.space)="setActiveNav('todays-list'); emitAwl()"
    >
      <mat-icon class="as-nav__icon">calendar_today</mat-icon>
      <span class="as-nav__label">
        {{ "GUI.Tabs.Today's List" | translate }}
      </span>
    </a>
  }

  <a
    class="as-nav__item"
    [class.as-nav__item--active]="activeNavItem === 'search-exams'"
    role="button"
    tabindex="0"
    (click)="setActiveNav('search-exams'); emitOpenEsearch(false)"
    (keyup.enter)="setActiveNav('search-exams'); emitOpenEsearch(false)"
    (keyup.space)="setActiveNav('search-exams'); emitOpenEsearch(false)"
  >
    <mat-icon class="as-nav__icon">search</mat-icon>
    <span class="as-nav__label">{{ 'GUI.General.Buttons.Search Exams' | translate }}</span>
  </a>

  @if (loginService.hasLeumit) {
    <a
      class="as-nav__item"
      [class.as-nav__item--active]="activeNavItem === 'reports'"
      role="button"
      tabindex="0"
      (click)="setActiveNav('reports'); emitOpenEsearch(true)"
      (keyup.enter)="setActiveNav('reports'); emitOpenEsearch(true)"
      (keyup.space)="setActiveNav('reports'); emitOpenEsearch(true)"
    >
      <mat-icon class="as-nav__icon">bar_chart</mat-icon>
      <span class="as-nav__label">{{ 'GUI.General.Buttons.Reports' | translate }}</span>
    </a>
  }

  @if (loginService.premissions?.Appointments) {
    <a
      class="as-nav__item"
      role="button"
      tabindex="0"
      (click)="redirectAdministration('appointments')"
      (keyup.enter)="redirectAdministration('appointments')"
      (keyup.space)="redirectAdministration('appointments')"
    >
      <mat-icon class="as-nav__icon">calendar_today</mat-icon>
      <span class="as-nav__label">{{ 'GUI.General.Buttons.Appointments' | translate }}</span>
      <mat-icon class="as-nav__external">open_in_new</mat-icon>
    </a>
  }

  @if (loginService.premissions?.Billings) {
    <a
      class="as-nav__item"
      role="button"
      tabindex="0"
      (click)="redirectAdministration('billing')"
      (keyup.enter)="redirectAdministration('billing')"
      (keyup.space)="redirectAdministration('billing')"
    >
      <mat-icon class="as-nav__icon">credit_card</mat-icon>
      <span class="as-nav__label">{{ 'GUI.General.Buttons.Billings' | translate }}</span>
      <mat-icon class="as-nav__external">open_in_new</mat-icon>
    </a>
  }
}
<!-- ======= Patients Nav (New) (End) ======= -->

<!-- ======= Patients Search Panel (Legacy) (Start) ======= -->
@if (!newSidebar) {
  <div class="userPanel">
    <i class="userPanel-icon icon-female"> </i>

    <div class="userPanel-userName">
      {{ 'GUI.Patients.titles.Patient Search' | translate }}
    </div>

    <div class="search-patient">
      <div class="search-patient-field">
        <div class="t-field l-flex t-twin-fieldset">
          <label>
            <input
              type="radio"
              name="idp"
              [(ngModel)]="idp"
              [value]="1"
              class="custom-check customInput"
              aria-labelledby="pregnancy_popup-sex"
            />
            <i class="customInput-display"></i>
            <span class="t-field-desc">
              {{ 'GUI.Patients.ID' | translate }}
            </span>
          </label>
          <label>
            <input
              type="radio"
              name="idp"
              [value]="0"
              class="custom-check customInput"
              aria-labelledby="pregnancy_popup-sex"
            />
            <i class="customInput-display"></i>
            <span class="t-field-desc">
              {{ 'GUI.Patients.Passport' | translate }}
            </span>
          </label>
        </div>
      </div>

      <div class="t-validation-wrap">
        <input
          type="text"
          class="search-patient-field idnumber"
          [ngClass]="invalidi"
          placeholder="{{ 'GUI.Placeholders.ID Number' | translate }}"
          [(ngModel)]="id"
          (keyup)="invalidi = ''; trysearch()"
          pattern="[A-Za-z0–9\-]+"
        />
        <div class="t-validation-message">
          <span>
            {{ 'GUI.Patients.Invalid ID Number' | translate }}
          </span>
        </div>
      </div>

      <div class="t-validation-wrap">
        <input
          type="text"
          class="search-patient-field"
          placeholder="{{ 'GUI.Placeholders.First Name' | translate }}"
          [ngClass]="invalidf"
          [(ngModel)]="first"
          (keyup)="invalidf = ''; trysearch()"
        />
        <div class="t-validation-message">
          <span>
            {{ 'GUI.Patients.Please fill in first name' | translate }}
          </span>
        </div>
      </div>

      <div class="t-validation-wrap">
        <input
          type="text"
          class="search-patient-field"
          placeholder="{{ 'GUI.Placeholders.Last Name' | translate }}"
          [ngClass]="invalidl"
          [(ngModel)]="last"
          (keyup)="invalidl = ''; trysearch()"
        />
        <div class="t-validation-message">
          <span>
            {{ 'GUI.Patients.Please fill in last name' | translate }}
          </span>
        </div>
      </div>

      <div class="t-validation-wrap">
        <input
          type="tel"
          class="search-patient-field"
          placeholder="{{ 'GUI.General.Patient Details Form.Mobile' | translate }} / {{ 'GUI.Placeholders.Phone' | translate }}"
          [(ngModel)]="phone"
          (keyup)="trysearch()"
        />
        <div class="t-validation-message">
          <span>
            {{ 'GUI.Patients.Invalid phone' | translate }}
          </span>
        </div>
      </div>

      <div class="l-flex l-flex-w t-fieldmargin search-btns">
        @if (loginService.premissions?.Dashboard) {
          <div class="w100">
            <button
              class="search-btn"
              matTooltipPosition="after"
              (click)="goToDashboard()"
              matTooltip="{{ 'GUI.dashboard.labels.dashboard' | translate }}"
            >
              {{ 'GUI.dashboard.labels.dashboard' | translate }}
            </button>
          </div>
        }
        @if (loginService.showAWL()) {
          <div class="w100">
            <button
              class="search-btn"
              matTooltipPosition="after"
              (click)="emitAwl()"
              matTooltip="{{ 'GUI.Tooltips.Artisan Worklist' | translate }}"
            >
              {{ 'GUI.General.Buttons.Today List' | translate }}
            </button>
          </div>
        }
        <div class="w50">
          <button
            class="search-btn"
            [disabled]="isSearchButtonDisabled"
            matTooltipPosition="after"
            (click)="emitSearch(true)"
            matTooltip="{{ 'GUI.Tooltips.Search Patient' | translate }}"
          >
            {{ 'GUI.General.Buttons.Search' | translate }}
          </button>
        </div>
        <div class="w50">
          <button
            class="search-btn"
            [class.search-btn--clear]="isSearchDisabled()"
            matTooltipPosition="after"
            (click)="clear()"
            matTooltip="{{ 'GUI.Tooltips.Clear Search Fields' | translate }}"
          >
            {{ 'GUI.General.Buttons.Clear' | translate }}
          </button>
        </div>
        <div class="w100">
          <button
            class="search-btn search-btn--newPatient"
            matTooltipPosition="after"
            (click)="requestAddPatient()"
            matTooltip="{{ 'GUI.Tooltips.Open New Patient' | translate }}"
          >
            {{ 'GUI.General.Buttons.New Patient' | translate }}
          </button>
        </div>
        <div class="w100">
          <button
            class="search-btn"
            matTooltip="{{ 'GUI.Tooltips.Search Exams' | translate }}"
            matTooltipPosition="after"
            (click)="emitOpenEsearch(false)"
          >
            {{ 'GUI.General.Buttons.Search Exams' | translate }}
          </button>
        </div>
        @if (loginService.hasLeumit) {
          <div class="w100">
            <button
              class="search-btn"
              matTooltip="{{ 'GUI.Tooltips.Reports for Leumit' | translate }}"
              matTooltipPosition="after"
              (click)="emitOpenEsearch(true)"
            >
              {{ 'GUI.General.Buttons.Reports' | translate }}
            </button>
          </div>
        }
        @if (loginService.premissions?.Appointments) {
          <div class="w100">
            <button
              class="search-btn"
              matTooltip="{{ 'GUI.Tooltips.Go to appointments' | translate }}"
              matTooltipPosition="after"
              (click)="redirectAdministration('appointments')"
            >
              {{ 'GUI.General.Buttons.Appointments' | translate }}
            </button>
          </div>
        }
        @if (loginService.premissions?.Billings) {
          <div class="w100">
            <button
              class="search-btn"
              matTooltip="{{ 'GUI.Tooltips.Go to billing' | translate }}"
              matTooltipPosition="after"
              (click)="redirectAdministration('billing')"
            >
              {{ 'GUI.General.Buttons.Billings' | translate }}
            </button>
          </div>
        }
      </div>
    </div>
  </div>

  <nav class="mainNav l-fg1 scroller"></nav>
}
<!-- ======= Patients Search Panel (Legacy) (End) ======= -->
